import { FaleComAgenteComponent } from './pages/fale-com-agente/fale-com-agente.component';
import { InternaComponent } from './pages/noticias/interna/interna.component';
import { SobreComponent } from './pages/sobre/sobre.component';
import { HorariosComponent } from './pages/horarios/horarios.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { HomeComponent } from './pages/home/home.component';
import { NoutFoundComponent } from './pages/nout-found/nout-found.component';
import { TrabalheConoscoComponent } from './pages/trabalhe-conosco/trabalhe-conosco.component';
import { NoticiasComponent } from './pages/noticias/noticias.component';
import { EvolucaoTarifariaComponent } from './pages/evolucao-tarifaria';

export const routes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'noticias', component: NoticiasComponent },
  { path: 'noticias/:id', component: InternaComponent },
  { path: 'sobre', component: SobreComponent },
  { path: 'horarios/:id', component: HorariosComponent },
  { path: 'fale-com-agente', component: FaleComAgenteComponent },
  { path: 'trabalhe-conosco', component: TrabalheConoscoComponent },
  { path: 'evolucao-tarifaria', component: EvolucaoTarifariaComponent },
  { path: '404', component: NoutFoundComponent },
  { path: '**', redirectTo: '/404' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
